module.exports = __webpack_public_path__ + "static/img/dag-features.a06cfad9.png";